// Los CSV que arma el motor de comisiones (nómina del corte, estado de cuenta) se bajan tal cual.
import type { EngineCsvExport } from '@/api/services/retail-commission/commissions.client';
import { downloadCsv } from '@/domains/retail/admin/promotions/lib/downloadCsv';

// El BOM hace que Excel en es-MX abra el archivo en UTF-8 y no parta los acentos.
const BOM = '\uFEFF';

export function downloadEngineCsv({ filename, csv }: EngineCsvExport): void {
    downloadCsv({ blob: new Blob([BOM, csv], { type: 'text/csv;charset=utf-8' }), filename });
}
